export interface NamedProperty {
    id: string;
    name: string;
}

export const defaultNamedProperty: NamedProperty = { id: "", name: "" };

export const sortNamedPropertyByName = (a: NamedProperty, b: NamedProperty): number => {
    const aName = a.name.toLowerCase();
    const bName = b.name.toLowerCase();

    if (aName < bName) {
        return -1;
    }

    if (aName > bName) {
        return 1;
    }

    return 0;
};
